module.exports = __webpack_public_path__ + "static/navbar3-cdf44a4c69c92f7c74527232534201fb.png";